import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import { Grid as InavistaGrid, GridConfig, GridHyperlinkClickEvent } from '@inavista/components/grid';
import { InventoryService } from 'projects/service/src/app/modules/home/services/inventory.service';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import { exportInavistaGrid } from 'projects/service/src/app/shared/utils/inavista-grid-export';
import { LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { HttpErrorResponse } from '@angular/common/http';
import { MasterItemcodePopupComponent } from 'projects/shared/src/lib/components/master-itemcode-popup/master-itemcode-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { buildShipmentDetailsItemsGridConfig, SHIPMENT_DETAILS_ITEMS_COLUMNS } from './shipment-details-items.grid.config';

// The old grid's content was (modal body height - 350) tall, with its toolbar and header above it.
// The inavista grid draws them inside its own box.
const GRID_CHROME_PX = 92;

@Component({
    selector: 'app-shipment-details-tab',
    templateUrl: './shipment-details-tab.component.html',
    styleUrls: ['./shipment-details-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    // The grid reads this.items, not an endpoint.
    providers: [...provideLocalGridRows()]
})
export class ShipmentDetailsTabComponent implements OnInit, OnChanges, OnDestroy {

  gridHeight: number;
  gridConfig: GridConfig = null;

  @Input() priorities: Object[];
  @Input() shipmentMethods: Object[];
  @Input() technicianAddresses: Object[];
  @Input() shipmentOrderId: any;
  @Input() shipmentOrderData: any;
  @Input() details: any;
  @Input() items: any;
  @Input() status: 'string';

  @ViewChild('deliveryAck') deliveryAck: CheckBoxComponent;
  @ViewChild('shipmentOrderItemsGrid') itemsGrid: InavistaGrid;

  @Output() updateStatus = new EventEmitter()
  isTechnician: boolean;
  orderId: any;
  partOrderData: any;
  showPopup: boolean = false;
  deliveryAcknowBtnDisabled: boolean = false
  private readonly gridRows = inject(LocalRowsGridApi);
  private shownItems: any[] = [];

  constructor(
    private inventoryService: InventoryService,
    private commonService: CommonService,
    private dialog: MatDialog,
  ) {
    this.deliveryAcknowBtnDisabled = this.commonService.roleClaims['Inv_Order_ReceiptGrid_Delivery_Acknowledged']?.disable;
  }

  ngOnInit(): void {
    this.isTechnician = this.commonService.USER.employeeId === this.shipmentOrderData.technicianId;
    this.gridHeight = document.getElementsByClassName('modal-body')[0].scrollHeight - 350 + GRID_CHROME_PX;
    this.gridRows.columns.set(LocalRowsGridApi.schema(SHIPMENT_DETAILS_ITEMS_COLUMNS));
    this.gridConfig = buildShipmentDetailsItemsGridConfig(!!this.commonService.roleClaims['AllGrid_Toolbar_Excel_Export']?.visible);
    this.refreshRows();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && !changes['items'].firstChange) {
      this.refreshRows();
    }
  }

  // The rows the grid shows: the items not deleted (the old Query isDeleted notequal true), numbered.
  refreshRows() {
    this.shownItems = (Array.isArray(this.items) ? this.items : []).filter(item => item?.isDeleted !== true);
    this.gridRows.rows.set(this.shownItems.map((item, i) => ({ ...item, __rowKey: i })));
    this.itemsGrid?.refresh();
  }

  getData() {
    return this.details;
  }

  showMasterItemCodePopup(eqData: any) {
      if (!eqData?.itemCode) return;
      const dialogRef = this.dialog.open(MasterItemcodePopupComponent, {
      panelClass: 'master-itemcode-popup-dialog',
      width: '80%',
      height: '80%',
      data: eqData
      });
      dialogRef.afterClosed().subscribe((result) => { });

  }

  // Part Order opens the parts order; Item and Description the item, as before.
  onHyperlinkClick(event: GridHyperlinkClickEvent) {
    const item = this.shownItems[event.row['__rowKey'] as number] ?? event.row;
    if (event.columnId === 'partsOrderRef') {
      this.onPartOrderClick(item);
    } else {
      this.showMasterItemCodePopup(item);
    }
  }

  // The old Excel export: the rows the grid shows, the visible columns, "Shipment Order(<date>).xlsx".
  onExportRequested() {
    exportInavistaGrid(this.itemsGrid, 'Shipment Order');
  }

  changeStatus(args) {
    this.commonService.showConfirmation('Delivery Acknowledgement will not be reverted and any other changes will be saved! Do you want to proceed?').then(result => {
      if (result.isConfirmed) {
        this.updateStatus.emit(args);
      } else {
        this.deliveryAck.checked = false;
      }
    });
  }

  onPartOrderClick(data) {
    this.orderId = data.partsOrderRef;
    // this.showLoader = true;
    this.inventoryService.getPartsOrderById(this.orderId)
      .subscribe((res: any) => {
        this.partOrderData = res.result;
        // this.showLoader = false;
        this.showPopup = true;
      }, (error: HttpErrorResponse) => {
        // this.showLoader = false;
        throw error;
      });
  }

  onClosePartsPopup() {
    this.showPopup = false;
    this.orderId = null;
    this.partOrderData = null;
  }

  partsOrderSaved(updatedData) {
    this.onClosePartsPopup();
  }
  ngOnDestroy() {
    this.details = null;
  }
}
